var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoiceSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 6,
    viewBox: "0 0 34 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 6,
    fill: "#00864F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    width: 6,
    height: 6,
    fill: "#00864F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    width: 10,
    height: 6,
    fill: "#00864F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceSuccessIcon);
export default __webpack_public_path__ + "static/media/voice-success-icon.ca2008d8f1ca5f10f6d59bf897b2a806.svg";
export { ForwardRef as ReactComponent };